function SuperAdminDashboard() {
  return <main className="flex flex-col w-full h-full">Dashboard</main>;
}

export default SuperAdminDashboard;
